module.exports = __webpack_public_path__ + "img/single-dependant.c9c0d35c.svg";